import { supabase } from "../backend/supabase";

export async function getCurrentToken() {
    const { data: { session } } = await supabase.auth.getSession()
    if (session) {
        // The JWT token is in session.access_token
        return session.access_token
    }
    return null // No active session
}